// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  padding: 1.2rem;
  background: #36f;
}

.page-error {
  font-family: "montserratbold";
  padding-top: 4 rem;
}

.pgContainer {
  min-height: 200px;
}`, "",{"version":3,"sources":["webpack://./src/app/system-common/page-not-found/page-not-found.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,6BAAA;EACA,kBAAA;AACF;;AAEA;EACE,iBAAA;AACF","sourcesContent":[".header {\r\n  padding: 1.2rem;\r\n  background: #36f;\r\n}\r\n\r\n.page-error {\r\n  font-family: 'montserratbold';\r\n  padding-top: 4 rem;\r\n}\r\n\r\n.pgContainer {\r\n  min-height: 200px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
